import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'styled-spread',
  templateUrl: './styled-spread.component.html',
  styleUrls: ['./styled-spread.component.scss'],
})
export class StyledSpreadComponent implements OnInit {
  @Input() src;

  constructor() {}

  ngOnInit() {}
}
